<template>
    <popup-wrapper
        class="popup-gift-card"
        v-if="popShow"
        @pop-cls="handlePopCls"
    >
        <h3 v-html="$t('popup.giftCard.title', { reward: rewardName })"></h3>
        <p v-html="$t('popup.giftCard.desc')"></p>
        <div class="input-wrapper">
            <label for="username" v-html="$t('popup.giftCard.name')"></label>
            <input
                type="text"
                name="username"
                placeholder="xxxxxx"
                autocomplete="off"
                v-model="username"
                :disabled="inputedName"
            />
        </div>
        <div class="input-wrapper">
            <label for="country" v-html="$t('popup.giftCard.country')"></label>
            <input
                type="text"
                name="country"
                placeholder="xxxxxx"
                autocomplete="off"
                v-model="country"
                :disabled="inputedCountry"
            />
        </div>
        <div class="input-wrapper">
            <label for="email" v-html="$t('popup.giftCard.email')"></label>
            <input
                type="text"
                name="email"
                placeholder="xxxxxx"
                autocomplete="off"
                v-model="email"
                :disabled="inputedEmail"
            />
        </div>
        <!-- 兑换按钮 -->
        <div class="btn-redeem" @click="handleRedeem" v-show="!inputedName">
            {{ $t('base.redeem_btn') }}
        </div>
    </popup-wrapper>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import popupWrapper from '@/components/popup/popup-wrapper';
import { isEmail } from '@/utils';
import i18n from '@/lang';

export default {
    name: 'popup-gift-card',
    components: {
        popupWrapper
    },
    data() {
        return {
            username: '',
            country: '',
            email: ''
        };
    },
    computed: {
        popShow() {
            return this.$store.state.popup.giftCard;
        },
        // 抽中的奖品
        drawReward() {
            return this.$store.state.drawReward;
        },
        // 礼包名
        rewardName() {
            const drawReward = this.drawReward;
            if (drawReward && drawReward.type_ename == 'shop_card') {
                return drawReward.item_name;
            } else {
                return '';
            }
        },
        inputedName() {
            const drawReward = this.drawReward;
            if (drawReward) {
                const item = drawReward.type_info.find(
                    item => item.ename == 'user_name'
                );
                console.log(item);
                if (item && item.value) {
                    this.username = item.value;
                    return true;
                }
                return false;
            } else {
                return false;
            }
        },
        inputedCountry() {
            const drawReward = this.drawReward;
            if (drawReward) {
                const item = drawReward.type_info.find(
                    item => item.ename == 'country'
                );
                if (item && item.value) {
                    this.country = item.value;
                    return true;
                }
                return false;
            } else {
                return false;
            }
        },
        inputedEmail() {
            const drawReward = this.drawReward;
            if (drawReward) {
                const item = drawReward.type_info.find(
                    item => item.ename == 'email'
                );
                if (item && item.value) {
                    this.email = item.value;
                    return true;
                }
                return false;
            } else {
                return false;
            }
        }
    },
    methods: {
        ...mapMutations(['PLAY_SOUND', 'STOP_SOUND']),
        ...mapActions(['fillDrawInfo', 'showComm']),
        // 购物卡兑换
        handleRedeem() {
            this.PLAY_SOUND('button');
            const { username, country, email } = this;
            if (!username) {
                this.showComm({
                    text: i18n.t('base.enter_name'),
                    size: 'mid'
                });
                return;
            }
            if (!country) {
                this.showComm({
                    text: i18n.t('base.enter_country'),
                    size: 'mid'
                });
                return;
            }
            if (!email) {
                this.showComm({
                    text: i18n.t('base.enter_email'),
                    size: 'mid'
                });
                return;
            }
            if (!isEmail(email)) {
                this.showComm({
                    text: i18n.t('base.enter_right_email'),
                    size: 'mid'
                });
                return;
            }
            this.fillDrawInfo({
                id: this.drawReward.id,
                user_name: username,
                country,
                email
            });
        },
        handlePopCls() {
            this.$store.commit('HIDE_ALL_POPUP');
        }
    }
};
</script>

<style lang="less" scoped>
/deep/ .popup-wrapper {
    box-sizing: border-box;
    padding: 45px 40px;

    h3 {
        font-size: 36px;
        color: #9c9273;
        text-align: center;
        margin-bottom: 24px;
        line-height: 1.2;
    }

    p {
        font-size: 24px;
        text-align: center;
        line-height: 1.5;
        color: #9c9273;
    }

    .input-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 32px;
        margin-left: 12px;

        label {
            font-size: 24px;
            color: #474747;
            margin-right: 24px;
            text-align: center;
            width: 30%;
        }

        input {
            width: 70%;
            // width: 344px;
            height: 55px;
            background: url(~@/assets/img/pop_input_bg.png) center/100% 100%
                no-repeat;
            padding-left: 20px;
            box-sizing: border-box;
            font-size: 24px;
            line-height: 55px;
            color: #9c9273;
            flex-shrink: 0;

            &::-webkit-input-placeholder {
                color: #e7e2d0;
            }
        }
    }

    .btn-redeem {
        width: 189px;
        height: 74px;
        background: url(~@/assets/img/btn_blue_square.png) center/100% 100%
            no-repeat;
        margin: 40px auto 0;
        line-height: 74px;
        font-size: 34px;
        color: #fff;
        text-align: center;
        font-weight: bold;
    }
}
</style>
